import { ref } from 'vue'
import { useAuth } from '@/entities/Auth'

export const useModel = () => {
  const auth = useAuth()

  const data = ref({
    notify_audio: auth.user?.notify_audio,
    notify_bubbles: auth.user?.notify_bubbles,
  })

  return {
    data,
  }
}
